import Base from './Base.js';

export default class ClientsAPI extends Base {
    getCouriers(kitchenCode) {
        return this.apiClient.get('users', { role_name: "courier", kitchen_code: kitchenCode, status: "active", per_page: "-1" });
    }
}
